<template>
	<!--
		Reusable skeleton block (HAP-1889, parent HAP-1884 Phase 2.1).

		One styled placeholder block with the shared subtle shimmer
		(.cfl-skeleton in index.css, reduced-motion aware). Size / position it
		with normal Tailwind utilities via the class attribute — they fall
		through to the root and merge with the base class, e.g.

			<Skeleton class="h-4 w-2/3 rounded-md" />
			<Skeleton circle class="w-12 h-12" />

		Decorative only, so it's hidden from the accessibility tree.
	-->
	<div
		class="cfl-skeleton"
		:class="circle ? 'rounded-full' : rounded"
		aria-hidden="true"
	/>
</template>

<script>
export default {
	name: 'Skeleton',
	props: {
		// Pill / avatar shape. Overrides `rounded`.
		circle: { type: Boolean, default: false },
		// Default corner rounding when not a circle; override per-use as needed.
		rounded: { type: String, default: 'rounded-md' },
	},
}
</script>
